import { auth } from "./axiosConfig";

export const AuthAPI = {
  authenticate: async function () {
    const response = await auth.request({
      url: `/auth?session=${sessionStorage.getItem("Session")}&user=${localStorage.getItem("User")}`,
      method: "GET",
    });

    localStorage.setItem("JWTToken", response.data.jwt);
    localStorage.setItem("Features", response.data.features);
    localStorage.setItem("Key", response.data.key);
    localStorage.setItem("uid", response.data.uid);
    sessionStorage.setItem("sid", response.data.sid);
    localStorage.setItem("packageType", response.data.config.packageType ?? null);
    localStorage.setItem("packageTierType", response.data.config.packageTierType ?? null);
  },
};

export default AuthAPI;
